import {createSlice, PayloadAction} from '@reduxjs/toolkit'

// Define a type for the slice state
interface UserState {
    needToUpdateData: string[]
}

// Define the initial state using that type
const initialState: UserState = {
    needToUpdateData: []
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setNeedToUpdateData: (state : UserState, action: PayloadAction<string[]>) => {
            state.needToUpdateData = action.payload
        }
    }
})

export const {
    setNeedToUpdateData
} = userSlice.actions

export default userSlice.reducer
